import { render, staticRenderFns } from "./agv-ri-discount.vue?vue&type=template&id=4eba6a12&scoped=true&lang=pug&"
import script from "./agv-ri-discount.vue?vue&type=script&lang=js&"
export * from "./agv-ri-discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba6a12",
  null
  
)

export default component.exports